/* eslint-disable class-methods-use-this */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import Loading from 'components/common/Loading';
import { loginWithAuthToken } from 'actions';

class HandleToken extends Component {
  componentDidMount() {
    let q = {};
    if (this.props.q) {
      q = this.props.q;
    }

    const { userId, authToken, tossTo, search } = q;
    let push_to = {pathname: '', search: ''};

    if (search) {
      push_to.search = '?search=' + search;
    }

    if (userId && authToken) {
      this.props.loginWithAuthToken(authToken, userId, () => {
        if (tossTo) {
          push_to.pathname = tossTo;
        } else {
          push_to.pathname = '/calendar';
        }

        this.props.push( push_to );
      }, () => {
        push_to.pathname = '/login';

        this.props.push( push_to );
      });
    } else {
      push_to.pathname = '/login';

      this.props.push( push_to );
    }
  }

  render() {
    return (
      <Loading withWrapper />
    );
  }
}

function mapStateToProps(state) {
  return {
    q: state.router.location.query,
  };
}

export default connect(mapStateToProps, {
  loginWithAuthToken,
  push,
})(HandleToken);



// WEBPACK FOOTER //
// ./src/app/containers/HandleToken.js